import React, { useEffect } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import App from './pages/index';
import Careers from './pages/careers';
import Contact from './pages/contact';
import Team from './pages/team';
import Reserve, { ReserveThanks } from './pages/reserve';
import PrivacyPolicy from './pages/privacypolicy';
import TermsOfService from './pages/tos';
import NotFound from './pages/404';
import Unsubscribe from './pages/unsubscribe';
import reportWebVitals from './reportWebVitals';

// Global smooth scroll with inertia
const lenis = new Lenis({
  duration: 0.9,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
});

// Exposed so pages can drive smooth scroll (e.g. tab links) and pause it
// behind modals. Lenis owns the scroll position, so plain window.scrollTo
// gets reverted; go through the instance instead.
if (typeof window !== 'undefined') window.__lenis = lenis;

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/reserve" element={<Reserve />} />
        <Route path="/reserve/thanks" element={<ReserveThanks />} />
        <Route path="/order" element={<Navigate to="/reserve" replace />} />
        <Route path="/purchase" element={<Navigate to="/reserve" replace />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/tos" element={<TermsOfService />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
